import React, { useCallback, useEffect } from 'react';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Button } from '@mui/material';
import { Add, ContactMail } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from '@tanstack/react-router';
import { DataGrid } from '@mui/x-data-grid';
import { actions } from '../ClientView.redux';
import ClientContactMethodsCell from './ClientContactMethodsCell';
import ClientContactMethodsEditModal from './ClientContactMethodsEditModal';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';

const ClientContactMethods = () => {
    const dispatch = useDispatch();
    const { client_id } = useParams({ from: '/clients/view/$client_id' });
    const hasLoaded = useSelector((state) => state.clientView.contactMethodsPreviouslyLoaded);
    const loading = useSelector((state) => state.clientView.contactMethodsLoading);
    const contactMethods = useSelector((state) => state.clientView.contactMethods);
    const loadContactMethods = (clientID) => dispatch(actions.loadContactMethods(clientID));

    const columns = [
        {
            field: 'cm_edit',
            headerName: 'Edit',
            width: 90,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => <ClientContactMethodsCell {...params} />,
        },
        { field: 'cm_type', headerName: 'Type', flex: 1, minWidth: 140, sortable: false },
        { field: 'cm_name', headerName: 'Name', flex: 1, minWidth: 150, sortable: false },
        { field: 'cm_value', headerName: 'Value', flex: 1, minWidth: 180, sortable: false },
        { field: 'cm_note', headerName: 'Note', flex: 1, minWidth: 180, sortable: false },
        { field: 'date_created', headerName: 'Date Added', flex: 1, minWidth: 150, sortable: false },
    ];

    const handleAddNew = useCallback(() => {
        dispatch(actions.openContactMethodEditModal(null));
    }, [dispatch]);

    useEffect(() => {
        if (!hasLoaded && !loading) {
            loadContactMethods(client_id);
        }
    }, [loadContactMethods, client_id, hasLoaded, loading]);

    return (
        <DashboardCard
            color={'blueGrey'}
            icon={<ContactMail />}
            topContent={'Contact Methods'}
            topLabel={
                <div>
                    <Button variant="contained" color="primary" size="small" startIcon={<Add />} onClick={handleAddNew}>
                        Add New
                    </Button>
                </div>
            }
            size="xl"
        >
            <div style={{ width: '100%' }}>
                <DataGrid
                    rows={contactMethods}
                    columns={columns}
                    getRowId={(row) => row.cm_id}
                    pagination
                    pageSizeOptions={[5, 10, 20, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    loading={loading}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableCellFocus
                    sx={{
                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                    }}
                    slots={{ pagination: NumberedDataGridPagination }}
                    autoHeight
                />
            </div>

            <ClientContactMethodsEditModal />
        </DashboardCard>
    );
};

export default ClientContactMethods;
